(function(){
  'use strict';

  angular
    .module('app')
    .directive('dinamicList', dinamicListDirective);

  function dinamicListDirective() {
    return {
      restrict: 'A',
      scope: {
        dinamicList: '=',
        dinamicListLabel: '@?',
        ngModel: '='
      },
      template: `
        <li
          ng-class="{'is-active': selectedItem === item}"
          ng-repeat="item in dinamicList"
          >
          <span ng-mouseover="vm.select(item)" ng-if="dinamicListLabel">{{item[dinamicListLabel]}}</span>
          <span ng-mouseover="vm.select(item)" ng-if="!dinamicListLabel">{{item}}</span>
        </li>
      `,
      require: ['ngModel'],
      transclude: true,
      link: dinamicListLink,
      controller: dinamicListController,
      controllerAs: 'vm'
    }

    function dinamicListLink(scope, element, attrs, ctrls){
      let ngModel = ctrls[0];
      scope.$watch('ngModel', (val) => scope.selectedItem = val)
      scope.$watch('selectedItem', (val, old) => ngModel.$setViewValue(val));
    }

    function dinamicListController($scope){
      let vm = this;
      vm.select = item => $scope.selectedItem = item;
    }

  }

})();
